export class GenericResponse<T extends GenericResponse<T>> {
  success: boolean | null = null;
  rescode: number | null = 0;
  message: string | null = null;
  objectId: number | null = 0;

  constructor(init?: Partial<GenericResponse<T>>) {
    Object.assign(this, init);
  }
}
